module.exports = __webpack_public_path__ + "img/LK.1ca4fdef.png";